import { put, takeLatest } from "redux-saga/effects";
import { call } from "typed-redux-saga";
import _ from "lodash";
import {
  postLikeRequest,
  postLikeSuccess,
  postLikeFailed,
  getFeedListRequest,
  getFeedListSuccess,
  getFeedListFailed,
  feedPostRequest,
  feedPostSuccess,
  feedPostFailed,
  getFeedDetailsRequest,
  getFeedDetailsSuccess,
  getFeedDetailsFailed,
  editFeedRequest,
  editFeedSuccess,
  editFeedFailed,
  deleteFeedSuccess,
  deleteFeedRequest,
  deleteFeedFailed,
  commentPostRequest,
  commentEditRequest,
  commentPostSuccess,
  commentEditSuccess,
  commentPostFailed,
  getMoreCommentsRequest,
  getMoreCommentsSuccess,
  getMoreCommentsFailed,
  deleteCommentSuccess,
  deleteCommentRequest,
  deleteCommentFailed,
  getRepliesRequest,
  getRepliesSuccess,
  getRepliesFailed,
  commentLikeRequest,
  commentLikeSuccess,
  commentLikeFailed,
  getHashTagPostsSuccess,
  getHashTagPostsFailed,
  getHashTagPostsRequest,
} from "../reducers/feeds/feedPost.reducer";
import feedPage from "../services/feedPage.services";
interface payloadInterface {
  type: String;
  payload: any;
}

function* createFeedPost({ payload }: payloadInterface) {
  // calling the API
  const response = yield* call(feedPage.createPost, payload);
  try {
    if (response.flag === true) {
      yield put(
        feedPostSuccess({
          message: _.get(response, "message", ""),
          data: _.get(response, "data", {}),
        })
      );
    } else {
      yield put(feedPostFailed({ message: _.get(response, "message", "") }));
    }
  } catch (error) {
    yield put(feedPostFailed({ message: _.get(error, "message", "") }));
  }
}

export function* createFeedPostWatcher() {
  yield takeLatest(feedPostRequest, createFeedPost);
}

function* editFeedPost({ payload }: payloadInterface) {
  // calling the API
  const response = yield* call(feedPage.editPost, payload);

  try {
    if (response.flag === true) {
      const responseData = _.get(response, "data.data", {});
      const existingPostData = _.get(payload, "data", {});
      // An article caption edit does not change its cover or article data.
      // Preserve the complete item supplied by the feed while applying the
      // successful update, because this endpoint can return only a partial
      // object (including an unusable cover URL).
      const updatedData =
        _.get(existingPostData, "post_type") === 1
          ? { ...responseData, ...existingPostData }
          : responseData;

      yield put(
        editFeedSuccess({
          message: _.get(response, "message", ""),
          data: updatedData,
        })
      );
    } else {
      yield put(editFeedFailed({ message: _.get(response, "message", "") }));
    }
  } catch (error) {
    yield put(editFeedFailed({ message: _.get(error, "message", "") }));
  }
}

export function* editFeedPostWatcher() {
  yield takeLatest(editFeedRequest, editFeedPost);
}

// function* getFeedList({ payload }: payloadInterface) {
//   // calling the API
//   const response = yield* call(feedPage.getList, payload);
//   try {
//     if (response.flag === true) {
//       yield put(
//         getFeedListSuccess({
//           message: _.get(response, "message", ""),
//           data: _.get(response, "data", {}),
//         })
//       );
//     } else {
//       yield put(getFeedListFailed({ message: _.get(response, "message", "") }));
//     }
//   } catch (error) {
//     yield put(getFeedListFailed({ message: _.get(error, "message", "") }));
//   }
// }

type FeedListApiResponse = {
  flag: boolean;
  message?: string;
  data?: any;
  errors?: any;
};

function* getFeedList({ payload }: payloadInterface) {

  let apiCall: (payload: any) => Promise<FeedListApiResponse>;
  if (payload.myPosts === "my-posts") {
    apiCall = feedPage.myPost;
  } else if (payload.myPosts === "my-article") {
    apiCall = feedPage.myArticles;
  } else if (payload.myPosts === "saved-article") {
    apiCall = feedPage.savedArticles;
  } else {
    apiCall = feedPage.getList;
  }

  const apiPayload = { ...payload };
  delete apiPayload.myPosts;

  const response = yield* call(apiCall, apiPayload);
  try {
    if (response.flag === true) {
      yield put(
        getFeedListSuccess({
          message: _.get(response, "message", ""),
          data: _.get(response, "data", {}),
          // Pass along the mode flag so the reducer can choose where to store data
          myPosts: payload.myPosts || false,
        })
      );
    } else {
      yield put(getFeedListFailed({ message: _.get(response, "message", "") }));
    }
  } catch (error) {
    yield put(getFeedListFailed({ message: _.get(error, "message", "") }));
  }
}


export function* getFeedListWatcher() {
  yield takeLatest(getFeedListRequest, getFeedList);
}

// calling like api

function* feedPostLike({ payload }: payloadInterface) {
  const response = yield* call(feedPage.postLike, payload);
  try {
    if (response.flag === true) {
      yield put(
        postLikeSuccess({
          message: _.get(response, "message", ""),
          data: _.get(response, "data.data", {}),
        })
      );
    } else {
      yield put(postLikeFailed({ message: _.get(response, "message", "") }));
    }
  } catch (error) {
    yield put(postLikeFailed({ message: _.get(error, "message", "") }));
  }
}

export function* getFeedLikeWatcher() {
  yield takeLatest(postLikeRequest, feedPostLike);
}

// calling feed details/ single post API

function* getFeedDetails({ payload }: payloadInterface) {
  const response = yield* call(feedPage.feedDetails, payload);
  try {
    if (response.flag === true) {
      yield put(
        getFeedDetailsSuccess({
          message: _.get(response, "message", ""),
          data: _.get(response, "data", {}),
        })
      );
    } else {
      yield put(
        getFeedDetailsFailed({ message: _.get(response, "message", "") })
      );
    }
  } catch (error) {
    yield put(getFeedDetailsFailed({ message: _.get(error, "message", "") }));
  }
}

export function* feedDetailWatcher() {
  yield takeLatest(getFeedDetailsRequest, getFeedDetails);
}

// delete feed post

function* feedPostDelete({ payload }: payloadInterface) {
  // calling the API
  const response = yield* call(feedPage.deleteFeed, payload);

  try {
    if (response.flag === true) {
      yield put(deleteFeedSuccess({ response: response }));
    } else {
      yield put(
        deleteFeedFailed({
          message: _.get(response, "message", ""),
          errors: _.get(payload, "errors", {}),
        })
      );
    }
  } catch (error) {
    yield put(deleteFeedFailed({ message: _.get(error, "message", "") }));
  }
}

export function* peopleDeleteWatcher() {
  yield takeLatest(deleteFeedRequest, feedPostDelete);
}

// post comment

function* createFeedComment({ payload }: payloadInterface) {
  // calling the API
  const response = yield* call(feedPage.commentPost, payload.formData);
  try {
    if (response.flag === true) {
      yield put(
        commentPostSuccess({
          message: _.get(response, "message", ""),
          data: _.get(response, "data", {}),
        })
      );
    } else {
      yield put(commentPostFailed({ message: _.get(response, "message", "") }));
    }
  } catch (error) {
    yield put(commentPostFailed({ message: _.get(error, "message", "") }));
  }
}

export function* createCommentPostWatcher() {
  yield takeLatest(commentPostRequest, createFeedComment);
}

// edit comment

function* editFeedComment({ payload }: payloadInterface) {
  const { id, formData } = payload;
  // calling the API
  const response = yield* call(feedPage.editComment, id, formData);
  try {
    if (response.flag === true) {
      yield put(
        commentEditSuccess({
          message: _.get(response, "message", ""),
          data: _.get(response, "data", {}),
        })
      );
    } else {
      yield put(commentPostFailed({ message: _.get(response, "message", "") }));
    }
  } catch (error) {
    yield put(commentPostFailed({ message: _.get(error, "message", "") }));
  }
}

export function* editCommentPostWatcher() {
  yield takeLatest(commentEditRequest, editFeedComment);
}

// get more comments

function* getMoreComments({ payload }: payloadInterface) {
  // calling the API
  const response = yield* call(feedPage.getCommentList, payload);
  try {
    if (response.flag === true) {
      yield put(
        getMoreCommentsSuccess({
          message: _.get(response, "message", ""),
          data: _.get(response, "data", {}),
        })
      );
    } else {
      yield put(
        getMoreCommentsFailed({ message: _.get(response, "message", "") })
      );
    }
  } catch (error) {
    yield put(getMoreCommentsFailed({ message: _.get(error, "message", "") }));
  }
}

export function* getCommentListWatcher() {
  yield takeLatest(getMoreCommentsRequest, getMoreComments);
}

// delete comment

function* commentDelete({ payload }: payloadInterface) {
  // calling the API
  const response = yield* call(feedPage.deleteComment, payload);
  try {
    if (response.flag === true) {
      yield put(deleteCommentSuccess({ response: response, payload: payload }));
    } else {
      yield put(
        deleteCommentFailed({
          message: _.get(response, "message", ""),
          errors: _.get(payload, "errors", {}),
        })
      );
    }
  } catch (error) {
    yield put(deleteCommentFailed({ message: _.get(error, "message", "") }));
  }
}

export function* commentDeleteWatcher() {
  yield takeLatest(deleteCommentRequest, commentDelete);
}

// get replies

function* getReplies({ payload }: payloadInterface) {
  // calling the API
  const response = yield* call(feedPage.getReplyList, payload);
  try {
    if (response.flag === true) {
      yield put(
        getRepliesSuccess({
          message: _.get(response, "message", ""),
          data: _.get(response, "data", {}),
        })
      );
    } else {
      yield put(getRepliesFailed({ message: _.get(response, "message", "") }));
    }
  } catch (error) {
    yield put(getRepliesFailed({ message: _.get(error, "message", "") }));
  }
}

export function* getReplyListWatcher() {
  yield takeLatest(getRepliesRequest, getReplies);
}

// calling comment like api

function* feedCommentLike({ payload }: payloadInterface) {
  const response = yield* call(feedPage.commentLike, payload);
  try {
    if (response.flag === true) {
      yield put(
        commentLikeSuccess({
          message: _.get(response, "message", ""),
          data: _.get(response, "data.data", {}),
        })
      );
    } else {
      yield put(commentLikeFailed({ message: _.get(response, "message", "") }));
    }
  } catch (error) {
    yield put(commentLikeFailed({ message: _.get(error, "message", "") }));
  }
}

export function* getFeedCommentLikeWatcher() {
  yield takeLatest(commentLikeRequest, feedCommentLike);
}

// calling hashtag posts
function* hashTagPosts({ payload }: payloadInterface) {
  const response = yield* call(feedPage.hashTagPosts, payload);
  try {
    if (response.flag === true) {
      yield put(
        getHashTagPostsSuccess({
          message: _.get(response, "message", ""),
          data: _.get(response, "data", {}),
        })
      );
    } else {
      yield put(
        getHashTagPostsFailed({ message: _.get(response, "message", "") })
      );
    }
  } catch (error) {
    yield put(getHashTagPostsFailed({ message: _.get(error, "message", "") }));
  }
}

export function* getHashTagPostWatched() {
  yield takeLatest(getHashTagPostsRequest, hashTagPosts);
}
